import { render } from "./HintVideo.vue?vue&type=template&id=37850f01"
import script from "./HintVideo.vue?vue&type=script&lang=js"
export * from "./HintVideo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__